// frontend-executive/src/features/balances/types/balances.types.ts
export type AccountType = 'cash' | 'noncash';

export interface BalanceItem {
    organization: string;
    accountName: AccountType;
    amount: number;
    currency: string;
    syncedAt: string;
}

export interface BalanceHistoryItem {
    timestamp: string;
    amount: number;
    change: number | null;
}

export interface BalancesResponse {
    data: BalanceItem[];
    updatedAt: string | null;
    isMock?: boolean; // ← Флаг для определения мок-данных
}

export interface Account {
    id: string;
    accountName: AccountType;
    currency: string;
    amount: number;
    syncedAt: string;
    history?: BalanceHistoryItem[];
}

export interface Organization {
    id: string;
    name: string;
    avatar: string;
    avatarGradient: string;
    accounts: Account[];
    totalByCurrency: Record<string, number>;
    totalByAccountName: Record<AccountType, number>;
}

export type BalanceFilterType = 'all' | AccountType;
export type BalanceFilterCurrency = 'all' | string;

export interface BalanceFilters {
    type: BalanceFilterType;
    currency: BalanceFilterCurrency;
    search: string;
}

export const TYPE_LABELS: Record<AccountType, { short: string; full: string }> = {
    cash: { short: 'Нал', full: 'Наличные' },
    noncash: { short: 'Безнал', full: 'Безналичные' },
};

export const TYPE_COLORS: Record<AccountType, { 
    dot: string; 
    text: string; 
    bg: string; 
    chart: string;
    border: string;
}> = {
    cash: {
        dot: 'bg-emerald-500',
        text: 'text-emerald-700 dark:text-emerald-400',
        bg: 'bg-emerald-50 dark:bg-emerald-900/10',
        chart: 'bg-emerald-500',
        border: 'border-emerald-200 dark:border-emerald-800',
    },
    noncash: {
        dot: 'bg-blue-500',
        text: 'text-blue-700 dark:text-blue-400',
        bg: 'bg-blue-50 dark:bg-blue-900/10',
        chart: 'bg-blue-500',
        border: 'border-blue-200 dark:border-blue-800',
    },
};

// Валюты с символами
export const CURRENCY_SYMBOLS: Record<string, string> = {
    RUB: '₽',
    USD: '$',
    EUR: '€',
    GBP: '£',
    CNY: '¥',
    JPY: '¥',
};

// Форматирование суммы
export function formatMoney(amount: number, currency: string): string {
    const formatter = new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
    const symbol = CURRENCY_SYMBOLS[currency] || currency;
    return `${formatter.format(amount)} ${symbol}`;
}